import Icon from '../components/Icon.vue'

Icon.register({
  'arrow-down': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9l-194.3 194.4c-9.4 9.4-24.6 9.4-33.9 0l-194.4-194.4c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3 0.4l114.8 120.5v-287.4c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-0.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrow-down.js
// module id = 623
// module chunks = 0